import React, { SVGProps } from 'react';

export const SearchIcon = (props: SVGProps<SVGSVGElement>) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
      {...props}
    >
      <path
        fill="currentColor"
        d="m17.942 17.058-3.201-3.2a7.254 7.254 0 0 0 1.717-4.691c0-4.021-3.27-7.292-7.291-7.292-4.021 0-7.292 3.27-7.292 7.292 0 4.02 3.27 7.291 7.292 7.291a7.254 7.254 0 0 0 4.69-1.717l3.201 3.2a.624.624 0 1 0 .884-.883ZM3.125 9.167a6.048 6.048 0 0 1 6.042-6.042 6.048 6.048 0 0 1 6.041 6.042 6.048 6.048 0 0 1-6.041 6.041 6.048 6.048 0 0 1-6.042-6.041Z"
      />
    </svg>
  );
};
